import { useEffect, useState } from 'react';
import featureFlagService, { FEATURES } from '../services/featureFlagService';

/**
 * Is the new company progress board on for this session.
 *
 * TWO FLAGS, NOT ONE (D1.12.4). `company_journey` stays the master gate for
 * journey-driven disclosure; this one only selects which board renders. The
 * new board needs both on, so a rollback can either drop back to the old board
 * (turn this one off) or retire journey disclosure entirely (turn both off)
 * without a deploy.
 *
 * SUBSCRIBED, NOT READ ONCE, for the same reason as useCompanyJourneyFlag:
 * Flagsmith initialises asynchronously from App.js, so a mount that beats init
 * reads hasFeature() against flags that have not loaded, and a remote flip
 * during an incident would never reach a dashboard that was already open.
 */
const useCompanyProgressFlag = () => {
  const [enabled, setEnabled] = useState(() =>
    featureFlagService.isFeatureEnabled(FEATURES.COMPANY_PROGRESS_BOARD),
  );

  useEffect(() => {
    const evaluate = () =>
      setEnabled(
        featureFlagService.isFeatureEnabled(FEATURES.COMPANY_PROGRESS_BOARD),
      );
    // Immediately as well as on change: Flagsmith may already have loaded
    // between the initializer above and this effect.
    evaluate();
    const unsubscribe = featureFlagService.onChange(evaluate);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  return enabled;
};

export default useCompanyProgressFlag;
